/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WhatsNewModalQueryVariables = {};
export type WhatsNewModalQueryResponse = {
    readonly system: {
        readonly releases: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly releaseDate: string | null;
                    readonly version: string;
                    readonly releaseNotes: ReadonlyArray<{
                        readonly note: string | null;
                        readonly task: string | null;
                        readonly type: string | null;
                    } | null> | null;
                };
            } | null> | null;
        } | null;
    } | null;
};
export type WhatsNewModalQuery = {
    readonly response: WhatsNewModalQueryResponse;
    readonly variables: WhatsNewModalQueryVariables;
};



/*
query WhatsNewModalQuery {
  system {
    releases {
      edges {
        node {
          releaseDate
          version
          releaseNotes {
            note
            task
            type
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "System",
    "kind": "LinkedField",
    "name": "system",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReleaseConnection",
        "kind": "LinkedField",
        "name": "releases",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReleaseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Release",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "releaseDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "version",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNote",
                    "kind": "LinkedField",
                    "name": "releaseNotes",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "note",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "task",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WhatsNewModalQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WhatsNewModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "54f7f2bce61dbadbb17e20a1f5a9612e",
    "id": null,
    "metadata": {},
    "name": "WhatsNewModalQuery",
    "operationKind": "query",
    "text": "query WhatsNewModalQuery {\n  system {\n    releases {\n      edges {\n        node {\n          releaseDate\n          version\n          releaseNotes {\n            note\n            task\n            type\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '371105854f6328a048e50e489cc8408c';
export default node;
